<app-dialog
  [headerLabel]="'LABEL.PAYMENT_REMINDERS_DISABLED' | translate"
  [primaryActionText]="'ACTION.GOT_IT' | translate"
  [dialogType]="dialogType"
>
  <div id="reminders-disabled-dialog">
    {{ 'DIALOG.REMINDERS.DISABLED_INFO' | translate }}
  </div>
</app-dialog>
